<template>
	<div v-if="show" class="user-info-mask" @click.stop="close">
		<div class="user-info" @click.stop>
			<div class="user-header">
				<div class="avatar">
					<head-image :name="user.nickName" :url="user.headImageThumb" :size="72" :online="user.online"
						@click.native="showFullImage()" radius="12px"> </head-image>
				</div>
				<div class="basic">
					<div class="nick-name">{{ displayName }}</div>
					<div class="sub-name">{{ user.userName }}</div>
				</div>
			</div>
			<div class="user-body">
				<div class="info-row">
					<div class="label">用户名</div>
					<div class="value">{{ user.userName || '-' }}</div>
				</div>
				<div class="info-row">
					<div class="label">昵称</div>
					<div class="value">{{ user.nickName || '-' }}</div>
				</div>
				<div class="info-row">
					<div class="label">性别</div>
					<div class="value">{{ user.sex === 0 ? '男' : user.sex === 1 ? '女' : '保密' }}</div>
				</div>
				<div class="info-row">
					<div class="label">个性签名</div>
					<div class="value">{{ user.signature || '暂无' }}</div>
				</div>
			</div>
			<div class="user-footer">
				<el-button v-if="isFriend" type="primary" @click="onSendMessage()">发消息</el-button>
				<el-button v-else type="primary" @click="onAddFriend()">加为好友</el-button>
			</div>
		</div>
	</div>


</template>

<script>
import HeadImage from './HeadImage.vue'

export default {
	name: "userInfo",
	components: {
		HeadImage
	},
	data() {
		return {
			show: false,
			user: {},
			pos: {
				x: 0,
				y: 0
			},
			remarkMap: {}
		}
	},
	mounted() {
		this.loadRemarks();
	},
	methods: {
		loadRemarks() {
			try {
				const remarks = localStorage.getItem('friend_remarks');
				if (remarks) {
					this.remarkMap = JSON.parse(remarks);
				}
			} catch (error) {
				console.error('加载备注失败:', error);
			}
		},
		open(user, pos) {
			// pos 目前已忽略，统一使用居中大面板展示
			this.show = true;
			this.user = user || {};
		},
		close() {
			this.show = false;
		},
		onSendMessage() {
			let user = this.user;
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: this.displayName,
				headImage: user.headImage,
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.show = false;
		},
		onAddFriend() {
			// 检查是否已经发送过申请
			this.$http({
				url: "/friend-request/check-sent/" + this.user.id,
				method: "GET"
			}).then((hasSent) => {
				if (hasSent) {
					this.$message.warning("您已经向对方发送过好友申请，请等待对方处理");
					return;
				}
				
				// 检查是否已经收到对方的申请
				this.$http({
					url: "/friend-request/check-received/" + this.user.id,
					method: "GET"
				}).then((hasReceived) => {
					if (hasReceived) {
						this.$message.warning("对方已经向您发送过好友申请，请先处理");
						return;
					}
					
					// 发送好友申请
					this.$http({
						url: "/friend-request/send",
						method: "POST",
						params: {
							toUserId: this.user.id
						}
					}).then(() => {
						this.$message.success("好友申请已发送，请等待对方处理");
					}).catch((error) => {
						this.$message.error(error.message || "发送申请失败");
					})
				}).catch((error) => {
					this.$message.error("检查申请状态失败");
				})
			}).catch((error) => {
				this.$message.error("检查申请状态失败");
			})
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$eventBus.$emit("openFullImage", this.user.headImage);
			}
		}
	},
	computed: {
		displayName() {
			return this.remarkMap[this.user.id] || this.user.nickName;
		},
		isFriend() {
			return this.friendStore.isFriend(this.user.id);
		}
	}
}
</script>

<style lang="scss" scoped>
.user-info-mask {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.03);
	display: flex;
	align-items: center;
	justify-content: center;
}

.user-info {
	width: 420px;
	max-width: 90vw;
	background-color: #ffffff;
	box-shadow: var(--im-box-shadow-dark);
	border-radius: 6px;
	padding: 20px 24px 18px 24px;
	box-sizing: border-box;

	.user-header {
		display: flex;
		align-items: center;
		margin-bottom: 16px;

		.avatar {
			margin-right: 16px;
		}

		.basic {
			flex: 1;
			text-align: left;

			.nick-name {
				font-size: 18px;
				font-weight: 600;
				color: #111827;
				margin-bottom: 4px;
			}

			.sub-name {
				font-size: 13px;
				color: #6b7280;
			}
		}
	}

	.user-body {
		border-top: 1px solid #edf0f3;
		border-bottom: 1px solid #edf0f3;
		padding: 10px 0 6px 0;

		.info-row {
			display: flex;
			font-size: 14px;
			line-height: 30px;
			text-align: left;

			.label {
				width: 80px;
				color: #6b7280;
			}

			.value {
				flex: 1;
				color: #111827;
				word-break: break-all;
			}
		}
	}

	.user-footer {
		padding-top: 14px;
		text-align: center;
	}
}
</style>
